"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Search = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));

var _Header = _interopRequireDefault(require("../shared/Header"));

var _CommonSections = _interopRequireDefault(require("../shared/CommonSections"));

var _utils = require("../utils");

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Search =
/*#__PURE__*/
function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));
    _this.dispatchSearch = _this.dispatchSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          params = _this$props.params,
          setAndFilter = _this$props.setAndFilter;

      if (this.props.context.isPublic) {
        if ((0, _utils.canUseDOM)() && window.utag) {
          (0, _utils.sendPublicView)();
        }
      }

      ListingsActions.setAndFilter((0, _utils.escapeHTML)(params.term));
    }
  }, {
    key: "dispatchSearch",
    value: function dispatchSearch(val) {
      this.props.dispatch(ListingsActions.fetchListingsIfNeeded());
      this.props.dispatch(ListingsActions.setAndFilter(val));
    }
  }, {
    key: "render",
    value: function render() {
      var term = this.props.params.term;
      var sanitizedTerm = (0, _utils.escapeHTML)(term);
      return _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12"
      }, _react.default.createElement(_reactHelmet.default, {
        title: this.props.context.getTitle("Search: ".concat(sanitizedTerm))
      }), _react.default.createElement(_Header.default, null), _react.default.createElement("h2", {
        id: "ac-search-results-for",
        style: {
          textTransform: 'none'
        }
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "ShowingResultsFor",
        values: {
          term: sanitizedTerm
        }
      })), _react.default.createElement("hr", null), _react.default.createElement(_CommonSections.default, null)));
    }
  }]);

  return Search;
}(_react.Component);

exports.Search = Search;
Search.propTypes = {
  dispatch: _propTypes.default.func,
  params: _propTypes.default.shape({
    term: _propTypes.default.string
  }),
  fetchListingsIfNeeded: _propTypes.default.func,
  setAndFilter: _propTypes.default.func
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}

var mapDispatchToProps = {
  fetchListingsIfNeeded: ListingsActions.fetchListingsIfNeeded,
  setAndFilter: ListingsActions.setAndFilter
};

var _default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/search/SearchContainer.js
// module id = 275
// module chunks = 0